(function () {
    'use strict';

    angular.module("imApp").factory("p2DataTaskLogsService", ['$ihttp', 'p2DataTaskService', function ($ihttp, p2DataTaskService) {
        let service = {
            getDataTaskLogs: function (parms) {
                return $ihttp.post({
                    method: 1632,
                    parameters: parms || {}
                });
            },
            loadP2DataTaskLogList: function (portal_user_keyno) {
                return p2DataTaskService.call(353, {
                    portal_user_keyno: portal_user_keyno
                });
            }
        };

        return service;
    }]);
})();
